var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.730469 16.5L9.99972 0.5L19.269 16.5H0.730469ZM2.44972 15.5H17.5497L9.99972 2.5L2.44972 15.5ZM9.99972 14.1154C10.1741 14.1154 10.3202 14.0564 10.4382 13.9385C10.5561 13.8205 10.6151 13.6744 10.6151 13.5C10.6151 13.3256 10.5561 13.1795 10.4382 13.0615C10.3202 12.9436 10.1741 12.8846 9.99972 12.8846C9.82535 12.8846 9.67919 12.9436 9.56124 13.0615C9.44331 13.1795 9.38434 13.3256 9.38434 13.5C9.38434 13.6744 9.44331 13.8205 9.56124 13.9385C9.67919 14.0564 9.82535 14.1154 9.99972 14.1154ZM9.49972 11.8846H10.4997V6.88463H9.49972V11.8846Z",
    fill: "#D37302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e07ac60f7a10667209ad1a9b8f5af4a6.svg";
export { ForwardRef as ReactComponent };